/**
 * 缴费管理模块翻译 - 中文
 * 包含：账单管理、收付计划、发票管理
 */
export default {
  paymentMgmt: {
    // ======== 账单管理 billing ========
    billing: {
      title: '账单管理',
      subtitle: '管理商户应收应付账单',
      addBill: '新增账单',
      editBill: '编辑账单',
      billList: '账单列表',
      billNo: '账单编号',
      merchantName: '商户名称',
      contractNo: '合同编号',
      billType: '账单类型',
      billTypeReceivable: '应收',
      billTypePayable: '应付',
      amount: '金额',
      dueDate: '应付日期',
      status: '状态',
      statusPending: '待支付',
      statusPartialPaid: '部分支付',
      statusPaid: '已支付',
      statusOverdue: '已逾期',
      statusCancelled: '已取消',
      remark: '备注',
      // 状态筛选
      filterByStatus: '状态筛选',
      allStatus: '全部状态',
      // 操作
      confirmReceipt: '确认收款',
      confirmPayment: '确认付款',
      viewDetail: '查看详情',
      generateInvoice: '生成发票',
      // 消息
      fetchFailed: '获取账单列表失败',
      addSuccess: '新增成功',
      editSuccess: '编辑成功',
      deleteConfirm: '确定要删除账单 "{billNo}" 吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
    },

    // ======== 收付计划 payment-plan ========
    paymentPlan: {
      title: '收付计划',
      subtitle: '管理合同收付计划',
      generatePlan: '生成计划',
      editPlan: '编辑计划',
      planList: '计划列表',
      planPeriod: '计划期次',
      planType: '计划类型',
      planTypeReceivable: '应收计划',
      planTypePayable: '应付计划',
      receivableAmount: '应收金额',
      payableAmount: '应付金额',
      paidAmount: '已付金额',
      unpaidAmount: '未付金额',
      dueDate: '应付日期',
      paidDate: '实付日期',
      invoiceStatus: '开票状态',
      invoiceStatusNone: '未开票',
      invoiceStatusApplied: '已申请',
      invoiceStatusInvoicing: '开票中',
      invoiceStatusInvoiced: '已开票',
      invoiceStatusFailed: '开票失败',
      invoiceStatusRedFlushed: '已红冲',
      merchantConfirmed: '商户确认',
      // 消息
      fetchFailed: '获取计划列表失败',
      generateSuccess: '生成计划成功',
      generateFailed: '生成计划失败',
      editSuccess: '编辑成功',
    },

    // ======== 收款登记 register ========
    register: {
      title: '收款登记',
      merchantSelect: '请选择商户',
      paymentDate: '收款日期',
      paymentMethod: '收款方式',
      bankReceiptNo: '银行回单号',
      receiver: '收款人',
      remark: '备注',
      billDetail: '账单明细',
      selectBill: '选择账单',
      billNo: '账单编号',
      contractNo: '合同编号',
      period: '账单周期',
      dueDate: '到期日',
      billAmount: '账单金额',
      paidAmount: '已收金额',
      owedAmount: '欠款金额',
      thisPayment: '本次收款',
      lateFee: '滞纳金',
      prepaymentOffset: '预收款冲抵',
      availableBalance: '可用余额',
      offsetAmount: '冲抵总额',
      distributeByRatio: '按比例拆分',
      voucherAndInvoice: '凭证 & 发票',
      totalOwed: '应收总额',
      totalPayment: '本次收款',
      totalOffset: '其中冲抵',
      cashPayment: '现金收款',
      confirmRegister: '确认登记收款',
      cancel: '取消',
      changeMerchant: '更换商户',
      changeMerchantConfirm: '更换商户将清空已选账单和冲抵信息，确定？',
      noMerchantSelected: '请先选择商户',
      noBillSelected: '请至少选择一个账单',
      noPaymentAmount: '本次收款金额和冲抵金额不能同时为0',
      overpaymentConfirm: '以下账单收款金额超过欠款，超出部分将记为预收款',
      registerSuccess: '收款登记成功',
      noPrepayment: '该商户无可用预收款',
    },

    // ======== 发票管理 invoice ========
    invoice: {
      title: '发票管理',
      subtitle: '管理数电票开具与记录',

      // 开票申请 request
      request: {
        title: '开票申请',
        subtitle: '商户提交开票申请',
        addRequest: '新建申请',
        editRequest: '编辑申请',
        requestNo: '申请编号',
        requestDate: '申请日期',
        merchantName: '商户名称',
        totalAmount: '开票金额',
        status: '状态',
        statusPending: '待处理',
        statusProcessing: '开票中',
        statusDone: '已完成',
        statusFailed: '失败',
        // 开票信息
        titleType: '发票抬头类型',
        titleTypeCompany: '企业',
        titleTypePersonal: '个人',
        buyerName: '开票抬头',
        buyerTaxNo: '税号',
        buyerPhone: '电话',
        buyerEmail: '邮箱',
        deliverType: '交付方式',
        deliverTypeWechat: '微信卡包',
        deliverTypeEmail: '邮箱',
        deliverTypeBoth: '两者',
        // 消息
        addSuccess: '申请提交成功',
        editSuccess: '修改成功',
        deleteConfirm: '确定要删除申请 "{requestNo}" 吗？',
        fetchFailed: '获取申请列表失败',
        submitFailed: '提交申请失败',
      },

      // 开票处理 process
      process: {
        title: '开票处理',
        subtitle: '财务人员处理开票申请',
        requestNo: '申请编号',
        merchantName: '商户名称',
        totalAmount: '开票金额',
        platformStatus: '平台状态',
        platformStatusPending: '待开票',
        platformStatusProcessing: '开票中',
        platformStatusSuccess: '成功',
        platformStatusFailed: '失败',
        invoiceType: '发票类型',
        invoiceTypeNormal: '数电普票',
        invoiceTypeSpecial: '数电专票',
        // 操作
        issueInvoice: '开具发票',
        syncStatus: '同步状态',
        viewDetail: '查看详情',
        // 消息
        issueSuccess: '开票成功',
        issueFailed: '开票失败',
        syncSuccess: '状态同步成功',
        syncFailed: '状态同步失败',
        fetchFailed: '获取待开票列表失败',
      },

      // 发票记录 record
      record: {
        title: '发票记录',
        subtitle: '查看和管理所有发票记录',
        recordNo: '记录编号',
        invoiceNo: '发票号码',
        requestNo: '申请编号',
        invoiceDate: '开票日期',
        invoiceAmount: '发票金额',
        invoiceType: '发票类型',
        status: '状态',
        statusActive: '有效',
        statusRedFlushed: '已红冲',
        redFlushReason: '红冲原因',
        redFlushTime: '红冲时间',
        pdfUrl: 'PDF下载',
        qrCode: '查验二维码',
        // 操作
        viewDetail: '查看详情',
        redFlush: '发票红冲',
        redFlushConfirm: '确定要对发票 "{invoiceNo}" 进行红冲吗？此操作不可撤销！',
        redFlushSuccess: '红冲成功',
        redFlushFailed: '红冲失败',
        deliver: '补交付',
        deliverSuccess: '交付成功',
        deliverFailed: '交付失败',
        // 消息
        fetchFailed: '获取发票记录失败',
        deleteConfirm: '确定要删除记录 "{recordNo}" 吗？',
      },
    },
  },
}
